
import React from "react";
import locations from '../data/ubicaciones';
import { Link } from 'react-router-dom';


const WhatsApp = () => {
  const openWhatsApp = (phone) => {
    window.open(`https://wa.me/${phone.replace(/\D/g, '')}`, '_blank');
  };

  return (
    <div className="page">
      <h1>Contacto por WhatsApp</h1>
        <Link to="/" className="back-button">
          ← Volver al inicio
        </Link>
      <div className="whatsapp-list">
        {locations.map((loc, index) => (
          <div 
            key={index} 
            className="whatsapp-card"
            onClick={() => openWhatsApp(loc.phoneNumber)}
          >
            <h3>{loc.locationName}</h3>
            <p>{loc.phoneNumber}</p>
            <button className="whatsapp-button">💬 Enviar mensaje</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhatsApp;